module.exports = __webpack_public_path__ + "img/LIFTlogo.c74777fd.png";